/* Search: (1) for queries of 2+ words, products whose TITLE contains every word are requested separately (Shopify title: search, independent of stock and ranking) and shown first; (2) responsive columns in the search dropdown (max 5). */
(function () {
  if (window.__bgExactFirst) return;
  window.__bgExactFirst = true;

  var css = document.createElement('style');
  css.textContent = '#predictive-search-results-products-list{grid-template-columns:repeat(auto-fill,minmax(max(14rem,calc(20% - 1rem)),1fr))!important}';
  document.head.appendChild(css);

  function norm(s) {
    return ' ' + String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim() + ' ';
  }

  function words(q) {
    return norm(q).trim().split(' ').filter(function (w) { return w; }).map(function (w) { return ' ' + w + ' '; });
  }

  function exactQuery(q) {
    var ws = norm(q).trim().split(' ').filter(function (w) { return w.length > 1; });
    if (words(q).length < 2 || !ws.length) return '';
    return ws.map(function (w) { return 'title:' + w; }).join(' AND ');
  }

  function keyOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return '';
    return a.getAttribute('href').split('?')[0];
  }

  var cache = {};

  function getExact(kind, q, done) {
    var eq = exactQuery(q);
    if (!eq) return null;
    var ck = kind + '|' + eq;
    if (cache[ck]) return cache[ck].cards || null;
    cache[ck] = { cards: null };
    var url;
    if (kind === 'p') {
      var el = document.querySelector('predictive-search');
      var u = new URL(location.origin + FoxTheme.routes.predictive_search_url);
      u.searchParams.set('q', eq);
      u.searchParams.set('resources[limit]', (el && el.dataset.resultsLimit) || 10);
      u.searchParams.set('resources[limit_scope]', 'each');
      u.searchParams.set('section_id', FoxTheme.utils.getSectionId(el));
      url = u.toString();
    } else {
      var u2 = new URL(location.origin + '/search');
      u2.searchParams.set('type', 'product');
      u2.searchParams.set('q', eq);
      url = u2.toString();
    }
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) {
        var d = new DOMParser().parseFromString(t, 'text/html');
        var l = d.getElementById(kind === 'p' ? 'predictive-search-results-products-list' : 'ProductsList');
        cache[ck].cards = l ? [].slice.call(l.children) : [];
        done();
      })
      .catch(function () { cache[ck].cards = []; });
    return null;
  }

  function reorder(list, q, kind) {
    var ws = words(q);
    if (!list || ws.length < 2) return;
    var exact = getExact(kind, q, schedule);
    if (exact && exact.length) {
      var have = {};
      [].slice.call(list.children).forEach(function (k) { have[keyOf(k)] = k; });
      var front = [];
      exact.forEach(function (c) {
        var key = keyOf(c);
        if (!key) return;
        if (!have[key]) have[key] = document.importNode(c, true);
        if (front.indexOf(have[key]) < 0) front.push(have[key]);
      });
      var cur = [].slice.call(list.children);
      var want = front.concat(cur.filter(function (k) { return front.indexOf(k) < 0; }));
      var ok0 = want.length === cur.length && want.every(function (k, i) { return k === cur[i]; });
      if (!ok0) want.forEach(function (k) { list.appendChild(k); });
    }
    var kids = [].slice.call(list.children);
    var hits = [];
    var rest = [];
    kids.forEach(function (k) {
      var t = k.querySelector('.product-card__title, [class*="card__title"]');
      var tn = norm(t ? t.textContent : '');
      var ok = ws.every(function (w) { return tn.indexOf(w) > -1; });
      (ok ? hits : rest).push(k);
    });
    if (!hits.length || !rest.length) return;
    var order = hits.concat(rest);
    var same = order.every(function (k, i) { return k === kids[i]; });
    if (same) return;
    order.forEach(function (k) { list.appendChild(k); });
  }

  function run() {
    var pl = document.getElementById('predictive-search-results-products-list');
    var inp = document.querySelector('predictive-search input[type="search"]');
    if (pl && inp && inp.value.trim()) reorder(pl, inp.value, 'p');
    if (/\/search\/?$/.test(location.pathname)) {
      var g = document.getElementById('ProductsList');
      var q = new URLSearchParams(location.search).get('q');
      if (g && q) reorder(g, q, 's');
    }
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 60);
  }

  function start() {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    run();
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
